export default "__VITE_ASSET__900c36a5__"